<template>
    <div class="form-module">
        <image-uploader
            v-model="ctn.items.image"
            :disabled="!enabled"
            :key="current_key">
        </image-uploader>
        <v-switch
            :disabled="!enabled"
            v-model="ctn.items.hr"
            label="Divisória">
        </v-switch>
        Selecione o tipo de formulário:<br/>
        <br/>
        <v-radio-group v-model="ctn.items.type">
            <v-radio
                v-for="n in items"
                :key="n.value"
                :label="`${n.label}`"
                :value="n.value"
                :disabled="!enabled"
            ></v-radio>
        </v-radio-group>
    </div>
</template>

<script>
import ImageUploader from './../ImageUploader/ImageUploader';

export default {
    props: [ 'disabled' ],
    components: {
        ImageUploader
    },
    data: function() {
        return {
            ctn: {
                items: {
                    image: '',
                    hr: false,
                    type: 0
                }
            },
            items: [
                { label: 'Contato', value: 0 },
                { label: 'Dados para cursos InCompany', value: 1 },
                { label: 'Solicitação - Dados de Empresa', value: 2 }
            ],
            current_key: 0,
            enabled: true
        }
    },
    created: function()
    {
        if( this.$props.disabled === true ) this.enabled = false;
        if(this.$attrs.value) {
            this.ctn.items = this.$attrs.value;
        }
        setTimeout(()=>{
            this.ctn.items.image += '.';
            this.ctn.items.image = this.ctn.items.image.slice(0,-1);
        },200);
    },
    methods: {
        getModuleData(){
            return this.ctn.items;
        }
    }
}
</script>

